// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"e4e9ddf0","352":"5b4b6519","893":"6be726ca"}[chunkId] + ".chunk.js";
};